import { ref } from 'vue';
import { toast } from 'vue-sonner';

const parkedCalls = ref([]);
const loadingListParkedCalls = ref(false);
const loadingParkCall = ref(false);
const loadingRetrieveCall = ref(false);
const loadingMergeCalls = ref(false);

export function useParkingCalls() {
  const listParkedCalls = async () => {
    loadingListParkedCalls.value = true;
    try {
      const { data } = await axios.get('/api/v1/pbx/parking/parked');
      parkedCalls.value = data.calls ?? [];
      return parkedCalls.value;
    } catch (e) {
      console.error(e);
      toast.error('Failed to fetch parked calls.');
    } finally {
      loadingListParkedCalls.value = false;
    }
  };

  const parkMyCall = async () => {
    loadingParkCall.value = true;
    try {
      await axios.post('/api/v1/pbx/parking/park-my-call');
    } catch (e) {
      console.error(e);
      toast.error('Failed to park the call.');
    } finally {
      loadingParkCall.value = false;
    }
  };

  const retrieveCall = async (uuid, dest) => {
    loadingRetrieveCall.value = true;
    try {
      await axios.post('/api/v1/pbx/parking/retrieve', {
        uuid,
        dest,
      });
    } catch (e) {
      console.error(e);
      toast.error('Failed to retrieve the call.');
    } finally {
      loadingRetrieveCall.value = false;
    }
  };

  const mergeCalls = async (uuid1, uuid2) => {
    loadingMergeCalls.value = true;
    try {
      await axios.post('/api/v1/pbx/parking/merge', {
        uuid_1: uuid1,
        uuid_2: uuid2,
      });
    } catch (e) {
      console.error(e);
      toast.error('Failed to merge calls.');
    } finally {
      loadingMergeCalls.value = false;
    }
  };

  return {
    parkedCalls,
    listParkedCalls,
    parkMyCall,
    retrieveCall,
    mergeCalls,
    loadingListParkedCalls,
    loadingParkCall,
    loadingRetrieveCall,
    loadingMergeCalls,
  };
}
